import React from 'react';
import { HeartIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="testimonios" style={{
    paddingTop: "25px",
    paddingBottom: "25px"
  }} data-id="element-171" data-mp="20qxh5n2fr6z1">
      
    </section>;
}